(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    customElements.define('slideshow-inline', class extends Core {
        defaultProps = {
            gap: window.gutterWidth,
            slidesPerView: 4
        }

        elements = {
            swiper: '[data-swiper]',
            pagination: '[data-pagination]',
            buttonPrev: '[data-button-prev]',
            buttonNext: '[data-button-next]'
        }

        render() {
            this._setSwiperProps();
            this._initSwiper();
            this._updateLayout();
            this._bindResize();
        }

        disconnectedCallback() {
            super.disconnectedCallback?.();
            if (this._onResize) window.removeEventListener('resize', this._onResize);
        }

        _bindResize() {
            this._resizeScheduled = false;
            this._onResize = () => {
                if (this._resizeScheduled) return;
                this._resizeScheduled = true;
                requestAnimationFrame(() => {
                    this._resizeScheduled = false;
                    this._updateLayout();
                });
            };
            window.addEventListener('resize', this._onResize);
        }

        _updateLayout() {
            this._refreshContainerWidth();
            this._setSwiperPadding();
            this._setSwiperButtonsPosition();
            this._setPaginationOffset();

            if (this.swiper) {
                if (this.withOffset) {
                    this.swiper.params.slidesOffsetBefore = this.offset;
                    this.swiper.params.slidesOffsetAfter = this.offset;
                }
                this.swiper.update();
            }
        }

        _refreshContainerWidth() {
            const containerInner = document.querySelector('[data-main-container-inner]');
            if (containerInner) window.containerInnerWidth = containerInner.offsetWidth;
        }

        _setPaginationOffset() {
            if (!this.$pagination) return;

            if (this.withOffset) {
                this.$pagination.style.setProperty('--offset', `${this.offset}px`);
            } else if (this.swiperPadding) {
                this.$pagination.style.setProperty('--offset', `${this.swiperPadding}px`);
            }
        }
        
        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, this.swiperProps);
        }

        _setSwiperProps() {
            this.swiperProps = {
                loop: this.withLoop,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: this.$buttonNext,
                    prevEl: this.$buttonPrev
                },
                breakpoints: {
                    1: {
                        slidesPerView: 1.5,
                        spaceBetween: this.gap
                    },
                    992: {
                        slidesPerView: this.slidesPerView,
                        spaceBetween: this.gap
                    }
                }
            };
            if(this.withOffset) {
                this.swiperProps.slidesOffsetBefore = this.offset;
                this.swiperProps.slidesOffsetAfter = this.offset;
            }
            if(this.$pagination) {
                this.swiperProps.pagination = {
                    el: this.$pagination,
                    type: 'bullets',
                    clickable: true
                }
                this._setPaginationOffset();
            }
        }
        
        _setSwiperButtonsPosition() {
            this.swiperPadding && this.$swiper.style.setProperty('--button-position', (this.swiperPadding - this.navButtonWidth / 2) + 'px');
        }

        _setSwiperPadding() {
            if (!this.hasAttribute('container')) return;

            const padding = Math.max(this.swiperPadding, 0);
            this.$swiper.style.paddingLeft = padding + 'px';
            this.$swiper.style.paddingRight = padding + 'px';
        }

        get slidesPerView() {
            return this.getAttribute('slides-per-view') 
                && +this.getAttribute('slides-per-view') 
                || this.defaultProps.slidesPerView;
        }
    
        get gap() {
            return this.getAttribute('gap') 
                && +this.getAttribute('gap') 
                || this.defaultProps.gap;
        }
        get withOffset() {
            return this.hasAttribute('offset');
        }
        get withLoop() {
            return this.hasAttribute('loop') && this.slidesCount > this.slidesPerView;
        }
        get slidesCount() {
            return Number(this.getAttribute('slides-count') || this.querySelectorAll('.swiper-slide').length);
        }
        get offset() {
            return (document.documentElement.offsetWidth - window.containerInnerWidth) / 2;
        }

        get swiperPadding() {
            return this.hasAttribute('container') && (document.documentElement.offsetWidth - window.containerInnerWidth) / 2;
        }

        get navButtonWidth() {
            return this.$buttonNext.offsetWidth;
        }
    })
})();